import React, {useEffect, useState} from 'react';
import {ToggleGroup} from '@forecast-it/design-system';
import {matchSaved} from './filter_util';

interface FilterOperatorsLevel {
	[key: string]: string | number | boolean | (string | number | boolean)[];
}

interface NestedFilterOperators {
	[key: string]: FilterOperatorsLevel[];
}

interface AppliedFilterOperators {
	[key: string]: NestedFilterOperators[];
}

interface FilterValue {
	section: string;
	filterType: string;
	id: string;
}

interface Filter {
	id: string;
	name: string;
	value: FilterValue[];
	operators: AppliedFilterOperators;
}

interface SavedFilterGroupProps {
	savedFilters: Filter[];
	appliedFiltersList: Filter[];
	appliedFilterOperators: AppliedFilterOperators;
	changeAppliedFilters: (value: FilterValue[], operators: AppliedFilterOperators) => void;
}

export const SavedFilterGroup: React.FC<SavedFilterGroupProps> = ({
	savedFilters,
	appliedFiltersList,
	appliedFilterOperators,
	changeAppliedFilters,
}) => {
	const [value, setValue] = useState<string>('');

	useEffect(() => {
		const initialActiveFilter = savedFilters.find(filter => matchSaved(filter, appliedFiltersList, appliedFilterOperators));

		if (initialActiveFilter && appliedFiltersList.length > 0) {
			setValue(JSON.stringify(initialActiveFilter));
		} else if (appliedFiltersList.length === 0) {
			setValue('');
		}
	}, [savedFilters, appliedFiltersList, appliedFilterOperators]);

	const onValueChange = (filterString: string) => {
		if (!filterString) {
			setValue('');
			return changeAppliedFilters([], {});
		}

		const filter: Filter = JSON.parse(filterString);
		setValue(filterString);
		return changeAppliedFilters(filter.value, filter.operators);
	};

	const newFilterOptions = savedFilters.map(filter => ({
		value: JSON.stringify(filter),
		label: filter.name,
		disabled: false, // Need to make this optional in DS
	}));

	return <ToggleGroup type="single" value={value} onValueChange={onValueChange} options={newFilterOptions} />;
};
